




















































































import { ScreenSize } from '@/main/components/constants';
import { openEdit } from '@/main/router/routerPath';
import { PageMode } from '@/main/utils/pageMode';
import { editFactory } from '@/main/pages';
import { PRInvoice } from '@/modules/sklad/PRInvoice';
import _ from 'lodash';
import { START_LOADING, END_LOADING } from '@/main/store/listEditTypes';
import { saveButton, deleteButton } from '@/main/utils/tableOperations';
import { showAlert } from '@/main/utils/notifications';
import { Cell, getColumnsRowMapObject } from '@/main/utils/table';
import { forceFileDownload, handleChange, handleRemove, validateFiletype } from '@/main/utils/fileHelper';
import { Dodavatel } from '@/modules/ciselnik/skladove/dodavatel';

import DropButtons from '@/modules/servis/zakazka/components/DropButtons.vue';

import { isUserPartsManager, OpenPartMaintenance } from '@/main/utils/commonFunctions';

import DmsPdfDialog from '#components/DmsPdfDialog.vue';
import DmsEditableTable from '#components/dms/layout/EditableTable.vue';

import { editMutations } from './store/types';
import { PRReturnPolozky } from './polozky';
import { DEPENDENT_TABLES, NAME, PRReturnAttachmentFiles as prReturnAttachmentFiles, TAB_NAMES, TABS, GRID_COLUMNS } from './constants';
import { PART_RETURN_REQUEST_STATUS, REPORT_FILE_TYPE } from '../constants';
import { store } from './store/edit';
import { apiProvider, prReturnTiskUrl, partPurCreditMemoUrl } from './api';
import { apiProvider as apiPolozkyProvider } from './polozky/api';

export default editFactory(NAME, store).extend({
	components: {
		PrinvoiceSelect: PRInvoice.components.Select,
		DodavatelSelect: Dodavatel.components.Select,
		DmsPdfDialog,
		DmsEditableTable,
		DropButtons,
	},
	data() {
		return {
			dependencies: {
				...DEPENDENT_TABLES,
			},
			showCreatePolozky: true,
			prReceiptButtonPrp: false,
			fileList: [] as any[],
			isPRInvoiceFlag: false,
			showTiskDialog: false,
			showPurCreditMemo: false,
			prReturnTiskUrl,
			partPurCreditMemoUrl,
			ndPohybdoklId: 0,
			handleChange,
			handleRemove,
			saveButton,
			deleteButton,
			prReturnAttachmentFiles,
			lstPrReturnButtons: [
				{ labelKey: '' as string | null, click: '' as string | null, disable: '' as string | boolean | null, exist: true as boolean | null },
			],
			screenSize: ScreenSize.TABLET,
			windowWidth: window.innerWidth,
			tabNames: TAB_NAMES,
			isPartsRefresh: false,
			gridCols: GRID_COLUMNS,
		};
	},
	watch: {
		polozkyCount(val) {
			if (val) {
				(this.$refs.polozky as any).refreshLayout();
			}
		},
	},
	computed: {
		isUserPartsManager(): boolean {
			return isUserPartsManager(this.pracovnik.PracovnikOzn, this.userRoles);
		},
		tabItems() {
			const tabItems = [];

			if (this.hasTabAccess(NAME, TABS.Hlavni)) tabItems.push(TAB_NAMES.HLAVNI);
			if (this.hasTabAccess(NAME, TABS.Attachment)) tabItems.push(TAB_NAMES.ATTACHMENT);

			return _.pick(TABS, tabItems);
		},
		mutationsMappers(): Record<string, string> {
			return {
				Prinvoice: `${this.storeUri}/${editMutations.ND_PR_RETURN_PRINVOICE_SELECT_MAPPER}`,
				dodavatel: `${this.storeUri}/${editMutations.ND_PRIJEMKA_DODAVATEL_SELECT_MAPPER}`,
			};
		},

		polozkyCount(): number {
			return this.dependentTables.PRReturnPolozky.rows.length;
		},
		isUzavren(): boolean {
			return !_.isNil(this.UzavreniDat);
		},
		allowDelete(): boolean {
			return this.StatusId === PART_RETURN_REQUEST_STATUS.APPROVE ? this.StatusId !== PART_RETURN_REQUEST_STATUS.APPROVE : !this.isUzavren;
		},
		allowSave(): boolean {
			return !this.isUzavren;
		},
		showApproveReject(): boolean {
			return this.StatusId !== PART_RETURN_REQUEST_STATUS.RAISE;
		},
		prijemkaTiskFilter(): object {
			return {
				PrijemkaId: this.PrijemkaId,
				PRInvoiceFlag: true,
				NdpohybdoklId: this.ndPohybdoklId,
				PrintDialog: true,
				ReportType: REPORT_FILE_TYPE[REPORT_FILE_TYPE.PDF],
				PrPartReturnId: this.PrPartReturnId,
			};
		},
		disableRaisePR(): boolean {
			return this.StatusId !== PART_RETURN_REQUEST_STATUS.DISABLE;
		},
		isCreditMemoDisabled(): boolean {
			return this.StatusId !== PART_RETURN_REQUEST_STATUS.APPROVE;
		},
		enabledDelete(): boolean {
			return this.StatusId !== PART_RETURN_REQUEST_STATUS.APPROVE;
		},
		vozidloFilter(): object {
			return { DodavatelId: this.DodavatelId };
		},
		prReturnButtons(): object {
			this.lstPrReturnButtons = [
				{ labelKey: 'RAISE_PR_RETURN', click: 'raisePrReturn', disable: this.disableRaisePR, exist: true },
				{ labelKey: 'APPROVE', click: 'approvePrReturn', disable: this.showApproveReject, exist: true },
				{ labelKey: 'REJECT', click: 'rejectPrReturn', disable: this.showApproveReject, exist: true },
				{ labelKey: 'PrintPurCreditMemo', click: 'prInvoiceClick', disable: this.isCreditMemoDisabled, exist: true },
			];
			return this.lstPrReturnButtons
				.filter((item) => ((item.labelKey !== undefined && item.labelKey != null)) && item.exist)
				.map((item) => ({
					labelKey: item.labelKey,
					click: () => { this.call(item.click); },
					exist: item.exist,
					disable: item.disable,
				}));
		},
		isTabletEnabled(): boolean {
			return this.windowWidth > this.screenSize;
		},
	},
	mounted() {
		if (this.loggedUser.DmsSys.PrReceiptButtonPrp) {
			this.showCreatePolozky = false;
			this.prReceiptButtonPrp = true;
		}

		window.addEventListener('resize', () => {
			this.windowWidth = window.innerWidth;
		});
	},
	methods: {
		OpenPartMaintenance,
		call(method: any) {
			(this as { [key: string]: any })[method]();
		},
		async saveClick() {
			if (!this.customValidation()) {
				return;
			}
			await this.save();
		},
		async prInvoiceClick() {
			try {
				this.startLoading();
				const { data: invoiceResp } = await apiProvider.generateInvoice(this.edit);
				if (invoiceResp) {
					this.showPurCreditMemo = true;
				}
			} catch (err) {
				this.logError(err as Error);
			} finally {
				this.endLoading();
			}
		},
		tiskPrijemky() {
			this.isPRInvoiceFlag = true;
			this.showTiskDialog = true;
		},
		async onPrintDialogClosed() {
			this.showTiskDialog = false;
			this.refreshPreviousPage = true;
		},
		async printInvoice() {
			this.showTiskDialog = true;
		},
		refreshFun() {
			this.fetchTableData();
		},
		loadedData() {
			this.mainCollapse.push(PRReturnPolozky.name);
		},
		async submitAttachmentUpload() {
			const file = this.fileList[0];
			if (file) {
				if (validateFiletype(file, 2000000, file.raw.type)) {
					const Uploadresult = await apiProvider.saveDocument(file, this.PrPartReturnId);
					if (Uploadresult) {
						showAlert({
							message: this.LocalizeChyboveHlasky('FileUploadSuccess'),
							title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
							options: {
								type: 'info',
							},
						});
					}
					this.fileList = [];
					await this.refreshTable(prReturnAttachmentFiles);
				} else {
					this.fileList = [];
					showAlert({
						message: this.LocalizeChyboveHlasky('NoDataFile'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'info',
						},
					});
				}
			} else {
				showAlert({
					message: this.LocalizeChyboveHlasky('SelectFile'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
			}
		},

		async pRFilesDelete(e: Event, cells: Cell[]) {
			const result = await apiProvider.deleteAttachamentDocuments(cells[0]);
			if (result) {
				showAlert({
					message: this.LocalizeChyboveHlasky('FileDeleteSuccess'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
			}
			await this.refreshTable(prReturnAttachmentFiles);
		},

		async pRFilesDownload(e: Event, cells: Cell[]) {
			this.$store.commit(`${this.storeUri}/${START_LOADING}`);
			const MappedRow = getColumnsRowMapObject(this.dependentTables.AttachmentFiles.columns, cells) as any;
			const file = await apiProvider.getDocuments(MappedRow.FILE_ID);
			forceFileDownload(`data:application/octet-stream;base64,${file.data}`, MappedRow.FILE_NAME);
			this.$store.commit(`${this.storeUri}/${END_LOADING}`);
		},

		async refreshPolozky() {
			if (_.isNull(this.PrInvoiceId) || _.isUndefined(this.PrInvoiceId)) {
				showAlert({
					message: this.LocalizeChyboveHlasky('Part_Return_Receipt_No_Validation'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
				return;
			}
			this.startLoading();
			const isDuplicatePRRequest = await apiProvider.IsDuplicatePRRequestExists(this.edit);
			if (isDuplicatePRRequest.data) {
				showAlert({
					message: this.LocalizeChyboveHlasky('Duplicate_PR_Request_Validation'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
				},
				});
				this.endLoading();
				return;
			}
			else{

			this.isPartsRefresh = true;
			const prreturn = await apiProvider.savePRReturn(this.edit);
			if (prreturn instanceof Error) {
				this.endLoading();
				return;
			}
			if (prreturn.data.PR_PART_RETURN_ID > 0) {
				this.edit.PrPartReturnId = prreturn.data.PR_PART_RETURN_ID;
				this.edit.StatusId = prreturn.data.STATUS_ID;
				await apiProvider.savePRReturnParts(this.edit);
			}
			this.endLoading();
			await this.changeUrlToEdit(this.PrPartReturnId!);
			await this.refreshTable(PRReturnPolozky.name);
			if (!this.mainCollapse.includes(PRReturnPolozky.name)) {
				this.mainCollapse.push(PRReturnPolozky.name);
			}
		}
		},
		openEditParts(event: any) {
			if (this.StatusId === PART_RETURN_REQUEST_STATUS.APPROVE || this.StatusId === PART_RETURN_REQUEST_STATUS.REJECT) {
				this.showErrorAlert({ message: 'NonEditableItem' });
				return;
			}
			openEdit(PRReturnPolozky.name, PageMode.EDIT, { props: true, id: event.data.ZAZNAM_ID, ncCelkPrpActual: this.NcCelkPrp });
		},
		openViewParts(event: any) {
			openEdit(PRReturnPolozky.name, PageMode.VIEW, { props: true, id: event.data.ZAZNAM_ID });
		},
		async ondeleteClick({ data }: { data: { ZAZNAM_ID: number } }) {
			await apiPolozkyProvider.deleteEntity(data.ZAZNAM_ID);
			await this.refreshTable(PRReturnPolozky.name);
			if (!this.mainCollapse.includes(PRReturnPolozky.name)) {
				this.mainCollapse.push(PRReturnPolozky.name);
			}
		},
		getPRItemData() {
			this.ItemData = this.dependentTables.PRReturnPolozky.rows.map((row: any) => {
				const ndNrIndex = this.dependentTables.PRReturnPolozky.cellNames!.ND_NR;
				const ndNR = row.cells[ndNrIndex];
				const vyrobekndOznIndex = this.dependentTables.PRReturnPolozky.cellNames!.VYROBEKND_OZN;
				const vyrobekndOzn = row.cells[vyrobekndOznIndex];
				const returnIndex = this.dependentTables.PRReturnPolozky.cellNames!.RETURN_QUANTITY;
				const returnQty = row.cells[returnIndex];
				const partIdIndex = this.dependentTables.PRReturnPolozky.cellNames!.NDPRIJEM_ID;
				const ndPrijem = row.cells[partIdIndex];				
				return ({ ND_NR: ndNR, VyrobekndOzn: vyrobekndOzn, RETURN_QUANTITY: returnQty, NdPrijemId: ndPrijem, PrPartReturnId: this.PrPartReturnId });
			});
		},
		async raisePrReturn() {
			this.startLoading();
			await this.getPRItemData();
			const { data: returnData } = await apiProvider.raisePrReturn(this.edit);
			if (returnData.length > 0) {
				showAlert({
					message: `${this.LocalizeChyboveHlasky('Qty_UnAvailable')} ${returnData}`,
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
				return false;
			}
			this.StatusId = PART_RETURN_REQUEST_STATUS.RAISE;
			await this.save();
			this.endLoading();
			return true;
		},
		async approvePrReturn() {
			this.startLoading();
			await this.getPRItemData();
			await apiProvider.approvePrReturn(this.edit);
			this.StatusId = PART_RETURN_REQUEST_STATUS.APPROVE;
			await this.save();
			this.endLoading();
		},
		async rejectPrReturn() {
			this.startLoading();
			await this.getPRItemData();
			await apiProvider.rejectPrReturn(this.edit);
			this.StatusId = PART_RETURN_REQUEST_STATUS.REJECT;
			await this.save();
			this.endLoading();
		},
		customValidation() {
			if (this.isCreateMode && !this.isPartsRefresh) {
				showAlert({
					message: this.LocalizeChyboveHlasky('Part_Refresh'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
				return false;
			}
			return true;
		},
	},
});
